import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { INewKnowledgeAreaLevel } from './knowledge-area-level.interface';

import { axiosApiInstance } from 'services/config';
import { IKnowledgeAreaLevel } from 'types/domain/knowledgeAreaLevel';
import { convertAllLevelsByKnowledgeArea } from 'utils/knowledge-area-levels/convertAllLevelsByKnowledgeArea';

class KnowledgeAreaLevelApi {
  async getAllLevelsByKnowledgeArea(
    knowledgeAreaId: number,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeAreaLevel[]> {
    const response: AxiosResponse<IKnowledgeAreaLevel[]> = await axiosApiInstance.get(
      `level/knowledge-area/${knowledgeAreaId}`,
      config,
    );

    return convertAllLevelsByKnowledgeArea(response.data);
  }

  async create(
    knowledgeAreaLevelData: INewKnowledgeAreaLevel,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeAreaLevel> {
    const response: AxiosResponse<IKnowledgeAreaLevel> = await axiosApiInstance.post(
      'level',
      knowledgeAreaLevelData,
      config,
    );
    return response.data;
  }

  async update(
    levelId: number,
    levelData: INewKnowledgeAreaLevel,
  ): Promise<IKnowledgeAreaLevel> {
    const response: AxiosResponse<IKnowledgeAreaLevel> = await axiosApiInstance.put(
      `level/${levelId}`,
      levelData,
    );
    return response.data;
  }

  async delete(levelId: number, config?: AxiosRequestConfig): Promise<void> {
    await axiosApiInstance.delete(`level/${levelId}`, config);
  }
}

export { KnowledgeAreaLevelApi };
